import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { IAuthState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const authModule: Module<IAuthState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default authModule
